import { render, staticRenderFns } from "./Dowjones-ExtraSpecial.vue?vue&type=template&id=289932b5&"
import script from "./Dowjones-ExtraSpecial.vue?vue&type=script&lang=js&"
export * from "./Dowjones-ExtraSpecial.vue?vue&type=script&lang=js&"
import style0 from "./Dowjones-ExtraSpecial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports